import { render, staticRenderFns } from "./Optica.vue?vue&type=template&id=52036368"
import script from "./Optica.vue?vue&type=script&lang=js"
export * from "./Optica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports